import {
  FILTER_LABELS_ROUTE,
  FINANCIAL_CLOSURE_ROUTE,
  FOODS_AND_PRODUCTS_ROUTE,
  INGREDIENTS_ROUTE,
  OFFERS_ROUTE,
  ORDERS_ROUTE,
} from '@/routes';

import { NavListKey } from './types';

type NavigationList = {
  [key in NavListKey]: {
    title: string;
    items: { label: string; route: string }[];
  };
};

export const navigationList: NavigationList = {
  orders: {
    title: 'NAVBAR.ORDERS',
    items: [
      {
        label: 'NAVBAR.ORDERS',
        route: ORDERS_ROUTE,
      },
      {
        label: 'NAVBAR.FINANCIAL_CLOSURE',
        route: FINANCIAL_CLOSURE_ROUTE,
      },
    ],
  },
  menu_settings: {
    title: 'NAVBAR.MENU_SETTINGS',
    items: [
      {
        label: 'NAVBAR.OFFERS',
        route: OFFERS_ROUTE,
      },
      {
        label: 'NAVBAR.FILTER_LABELS',
        route: FILTER_LABELS_ROUTE,
      },
    ],
  },
  menu: {
    title: 'NAVBAR.MENU',
    items: [
      {
        label: 'NAVBAR.INGREDIENTS',
        route: INGREDIENTS_ROUTE,
      },
      {
        label: 'NAVBAR.FOODS',
        route: FOODS_AND_PRODUCTS_ROUTE,
      },
      // ...(window.ENVIRONMENT === 'development'
      //   ? [
      //       {
      //         label: 'NAVBAR.MENU',
      //         route: MENU_ROUTE,
      //       },
      //     ]
      //   : []),
    ],
  },
};
